import {store} from "../redux/store";
import {setParentInfopage} from "../redux/actions/setParentInfopage";
import {getParentInfopage} from "../action/getParentInfopage";

export const parentInfopageLoader = async (args) => {

    store.dispatch(setParentInfopage(await getParentInfopage(args.params.id)));
    return true;
}
